package presentation.screens.login

import utils.UiAction
import utils.UiState

data class LoginState(
    val isLoading: Boolean = false,
    val error: ErrorType? = null,
    val email: String = "",
    val isLoginError: Boolean = false,
    val password: String = "",
    val passwordVisible: Boolean = false,
    val isPasswordError: Boolean = false,
) : UiState {

    sealed interface ErrorType {
        data object Credential : ErrorType
        data object Verification : ErrorType
        data object Unknown : ErrorType
    }
}

sealed interface LoginMVIAction : UiAction {

    data class PasswordChanged(val password: String) : LoginMVIAction
    data class EmailChanged(val email: String) : LoginMVIAction
    data object LoginClicked : LoginMVIAction
    data object HidePasswordClicked : LoginMVIAction
    data object ForgotPasswordClicked : LoginMVIAction
    data object ErrorDismissed : LoginMVIAction
    data object BackPressed : LoginMVIAction
}
